/* override functions api.jquery.js */
Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.cart-item-loop');
};

// Replace single dishes with bundle variant ID
window.upcartOnCartUpdated = (cart) => {
  // Glass dish: 50315914379580
  // Tray: 48855009100092
  // Combo: 50541840171324
  console.log('upcartOnCartUpdated', cart);
  if (cart.items.some((item) => item.variant_id == 50315914379580)) {
    let updates = {};
    let bundleData = {};
    const glassDishQuantity = cart.items.filter((item) => item.variant_id == 50315914379580).map((item) => item.quantity).reduce((a, b) => a + b, 0);

    if (cart.items.some((item) => item.variant_id == 48855009100092)) {

      const thermalDishQuantity = cart.items.filter((item) => item.variant_id == 48855009100092).map((item) => item.quantity).reduce((a, b) => a + b, 0);
      const bundles = Math.min(glassDishQuantity, thermalDishQuantity);

      bundleData = {
        'items': [{
        'id': 50541840171324,
        'quantity': bundles
        }]
      };

      updates = {
        50315914379580: (glassDishQuantity - bundles),
        48855009100092: (thermalDishQuantity - bundles)
      };

    } else if (cart.items.some((item) => item.variant_id == 48855009132860)) {

      const thermalDish2x2Quantity = cart.items.filter((item) => item.variant_id == 48855009132860).map((item) => item.quantity).reduce((a, b) => a + b, 0);
      const bundles = Math.min(glassDishQuantity, thermalDish2x2Quantity);

      bundleData = {
        'items': [{
        'id': 50542035239228,
        'quantity': bundles
        }]
      };

      updates = {
        50315914379580: (glassDishQuantity - bundles),
        48855009132860: (thermalDish2x2Quantity - bundles)
      };

    } else if (cart.items.some((item) => item.variant_id == 48855009165628)) {

      const thermalDish3x2Quantity = cart.items.filter((item) => item.variant_id == 48855009165628).map((item) => item.quantity).reduce((a, b) => a + b, 0);
      const bundles = Math.min(glassDishQuantity, thermalDish3x2Quantity);

      bundleData = {
        'items': [{
        'id': 50542024589628,
        'quantity': bundles
        }]
      };

      updates = {
        50315914379580: (glassDishQuantity - bundles),
        48855009165628: (thermalDish3x2Quantity - bundles)
      };

    } else if (cart.items.some((item) => item.variant_id == 50542024589628)) {

      const thermalDish3x3Quantity = cart.items.filter((item) => item.variant_id == 50542024589628).map((item) => item.quantity).reduce((a, b) => a + b, 0);
      const bundles = Math.min(glassDishQuantity, thermalDish3x3Quantity);

      bundleData = {
        'items': [{
        'id': 50540687917372,
        'quantity': bundles
        }]
      };

      updates = {
        50315914379580: (glassDishQuantity - bundles),
        50542024589628: (thermalDish3x3Quantity - bundles)
      };

    }

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then(response => {
      return response.json();
    })
    .then(json => {
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(bundleData)
      })
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
};

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  var formatMoney = "";
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {

      cart_cell.empty();

      jQuery.each(cart, function(key, value) {

        if (key === 'items') {
      
          if (value.length) {
            jQuery(".cart-item-loop, .cart-item-title, .subtotal-title-area").css({"display": "block"});
            jQuery(".cart-empty-title").css({"display": "none"});
            
            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              jQuery('<li class="cart-item"><div class="cart-image"><a href="'+item.url+'"><img src="'+item.image+'" alt="'+ item.alt+'" width="'+item.image.width+'" height="'+item.image.height+'" class="img-fluid"></a></div><div class="cart-title"><a href="' + item.url + '">' + item.title.substring(0, 50) +'</a><div class="cart-pro-info"><div class="cart-qty-price"><span class="quantity-'+item.id+'">' + item.quantity + '</span> × <span class="price-box"><span class="new-price">' + Shopify.formatMoney(item.price, "") + '</span></span></div><div class="product-quantity-action"><div class="product-quantity" data-variant="'+item.id+'"><div class="cart-plus-minus"><div class="dec qtybutton">-</div><input value="'+item.quantity+'" type="text" name="quantity" min="1" pattern="[0-9]*"><div class="inc qtybutton">+</div></div></div><div class="delete-item-cart"><a class="remove_from_cart" href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ')"><i class="feather-trash-2"></i></a></div></div></div></div></li>').appendTo(table);
            });
          }
          else {
            jQuery(".cart-item-loop, .cart-item-title, .subtotal-title-area").css({"display": "none"});
          jQuery(".cart-empty-title").css({"display": "block"});
          }
        }
      });
    }
  }
  
  //console.log(cart.total_price);
  
  jQuery(".subtotal-price").html(Shopify.formatMoney(cart.total_price, ""));
  jQuery(".bigcounter").html(cart.item_count);

  jQuery('.currency .active').trigger('click');
  ///location.reload(true);
}

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};